export default ".col-row {\n  display: grid;\n}";